import styled from 'styled-components'
import colors from '../../../../constants/colors'
import { ButtonRound } from '../../../../constants/buttons'
import { SmallText } from '../../../../constants/typography'

export const Wrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`

export const ActionsWrap = styled.div`
  position: relative;

  display: flex;
  justify-content: space-evenly;
  align-items: center;

  margin-bottom: 40px;
`

export const ButtonCancel = styled(ButtonRound)`
  background: ${colors.secondary};
`

export const ButtonEmailSubmit = styled(ButtonRound)<{
  variant: 'default' | 'error'
}>`
  background: ${({ variant }) =>
    variant === 'error' ? colors.error : colors.alpha};

  svg {
    transform: rotate(180deg);
  }
`

export const ButtonLabel = styled(SmallText)`
  position: absolute;
  bottom: -30px;
  color: ${colors.alpha};
  opacity: 0.65;
`

interface IInputWithErrorProps {
  hasError: boolean
}

export const Input = styled.input<IInputWithErrorProps>`
  width: 80%;
  margin: 20px auto 30px 10%;

  text-align: center;
  font-size: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  border: 0;
  border-bottom: 2px solid
    ${({ hasError }) => (hasError ? colors.error : colors.gray100)};

  &:focus {
    outline: 0;
  }
`

export const ErrorText = styled(SmallText)`
  text-align: center;
  margin-top: 0;
  margin-bottom: 32px;
  color: ${colors.error};
`
